import React, {useState} from 'react'
import { Button, Container, Form, Row } from 'react-bootstrap'
import Services from './../../service';
import Swal from 'sweetalert2';
import MySpinner from './../Spinner';

const Subcribe = () => {
    const [Load, setLoad] = useState(false)
    const [Email, setEmail] = useState('')

    const submitSubscribe = async (e) => {
        e.preventDefault();
        setLoad(true)
        
        var data = {email: Email}

        await Services.AddSubscriber(data)
        .then((res) => {
            setLoad(false);
            Swal.fire({
                title: 'Success!',
                text: 'Thank You for Subscribe us',
                icon: 'success',
                showConfirmButton: false,
                timer: 1300
            })
            setEmail('')
            
        }).catch((err) => {
            setLoad(false);

            Swal.fire({
                title: 'Error!',
                text:  err.response.data.error ? err.response.data.error.email : 'Subscribe Error',
                icon: 'error',
                showConfirmButton: false,
                timer: 1300
            })

            setEmail('')

            console.log('error Add Subscriber :', err.response.data)
        })
    }

    return (
        <Container fluid>
            {Load && <MySpinner />}
            <Row>
                <div className="justify-content-center align-items-center d-none d-lg-flex bg-medium-grey">
                    <div>
                        <h3 className="text-dark m-0">STAY UP-TO-DATE WITH THE LATEST INFORMATION.</h3>
                    </div>
                    <div className="subscribe-holder">
                        <Form>
                            <Form.Group className="input-group m-3">
                                <Form.Control type="text" className="subscribe-form"
                                    name="subscribe"
                                    autoComplete="off"
                                    value={Email}
                                    onChange={e => setEmail(e.target.value)}
                                    placeholder="Enter Your Email Address" />
                                <Button type="button" className="form-control btn btn-submit-subscribe" onClick={(e) => submitSubscribe(e)}>
                                    Subscribe
                                </Button>
                            </Form.Group>
                        </Form>
                    </div>
                </div>
            </Row>
        </Container>
    )
}

export default Subcribe
